import routes from '@configs/api'

export const GET_LIVE_COURSE_URL = (course_id: string) => {
  return routes.COURSE + course_id + '/live'
}
export const GET_ALL_COURSES_URL = (query: string) => {
  return `${routes.COURSE}?${query}`
}
export const GET_USER_CART_URL = () => {
  return routes.USER_CART
}
export const GET_USER_WISHLIST_URL = () => {
  return routes.USER_WISHLIST
}
export const GET_USER_SAVED_ITEMS = () => {
  return routes.USER_SAVED_ITEMS
}
